var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 271.315,
    height: 70,
    viewBox: "0 0 271.315 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_81",
    "data-name": "\\uC0AC\\uAC01\\uD615 81",
    width: 271.315,
    height: 70,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_114",
    "data-name": "\\uADF8\\uB8F9 114",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_252",
    "data-name": "\\uD328\\uC2A4 252",
    d: "M0,0H40.72c16.6,0,24.988,6.77,24.988,16.881,0,7.533-4.483,12.493-10.587,14.781,7.822,2.574,13.446,8.486,13.446,17.642,0,11.157-8.486,18.882-25.654,18.882H0ZM37.67,26.226c4.388,0,6.865-1.906,6.865-4.958,0-2.958-2.478-4.579-6.77-4.579H22.41v9.537Zm1.049,24.509c5.053,0,8.01-1.718,8.01-5.436,0-3.148-2.193-5.245-7.723-5.245H22.41V50.735Z",
    transform: "translate(0 0.001)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_253",
    "data-name": "\\uD328\\uC2A4 253",
    d: "M37.655,0h22.6V48.351H93.348V68.186H37.655Z",
    transform: "translate(35.872 0.001)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_254",
    "data-name": "\\uD328\\uC2A4 254",
    d: "M68.619,40.148V0h22.6V38.527c0,8.01,4.388,12.491,12.682,12.491s12.684-4.481,12.684-12.491V0h22.6V39.672c0,15.356-6.676,30.326-35.477,30.326-28.608,0-35.095-14.781-35.095-29.85",
    transform: "translate(65.369 0.001)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_255",
    "data-name": "\\uD328\\uC2A4 255",
    d: "M168.073,18.693V0h-59.7V68.186h59.7V49.494h-37.1V42.3h33.394v-16.4H130.977v-7.2Z",
    transform: "translate(103.242 0.001)",
    fill: "#1a1818"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueM);
export default __webpack_public_path__ + "static/media/blue_m.d708a0739dffa4e90b05fc815f0ec4bb.svg";
export { ForwardRef as ReactComponent };